import { render, staticRenderFns } from "./scanToPayForm.vue?vue&type=template&id=24c56cb4&"
import script from "./scanToPayForm.vue?vue&type=script&lang=ts&"
export * from "./scanToPayForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports